export default __webpack_public_path__ + "static/obs-dashboards-e63a4b1977776ee2b9c501179b131a30.png";